import store from '../store';
import { frontendURL } from './URLHelper';
import { FEATURE_FLAGS } from '../featureFlags';
import { setCookieWithDomain } from './../../sdk/cookieHelpers';

export const ensureSuperAdmin = (to, from, next) => {
  const currentUser = store.getters.getCurrentUser || {};
  if (currentUser.type === 'SuperAdmin') {
    next();
    return;
  }
  next(frontendURL(`accounts/${to.params.accountId}/dashboard`));
};

let pendingAccountFetch = null;

export const ensureAccountLoaded = async accountId => {
  const account = store.getters['accounts/getAccount'](accountId);
  if (account && account.id) {
    return;
  }
  if (!pendingAccountFetch) {
    pendingAccountFetch = store.dispatch('accounts/get').finally(() => {
      pendingAccountFetch = null;
    });
  }
  await pendingAccountFetch;
};

export const ensureOpportunityPipelinesEnabled = async (to, from, next) => {
  const accountId = Number(to.params.accountId);
  await ensureAccountLoaded(accountId);
  const isEnabled = store.getters['accounts/isFeatureEnabledonAccount'](
    accountId,
    FEATURE_FLAGS.OPPORTUNITY_PIPELINES
  );
  if (isEnabled) {
    next();
    return;
  }
  next(frontendURL(`accounts/${to.params.accountId}/dashboard`));
};

export const ensureOpportunityPipelinesManagementAllowed = async (
  to,
  from,
  next
) => {
  const accountId = Number(to.params.accountId);
  await ensureAccountLoaded(accountId);
  const isAllowed = store.getters[
    'accounts/isOpportunityPipelinesManagementAllowed'
  ](accountId);
  if (isAllowed) {
    next();
    return;
  }
  next(frontendURL(`accounts/${to.params.accountId}/dashboard`));
};

export const ensureOpportunityKanbanAccessAllowed = async (to, from, next) => {
  const accountId = Number(to.params.accountId);
  await ensureAccountLoaded(accountId);
  const isAllowed = store.getters['accounts/isOpportunityKanbanAccessAllowed'](
    accountId
  );
  if (isAllowed) {
    next();
    return;
  }
  next(frontendURL(`accounts/${to.params.accountId}/dashboard`));
};

export const getCurrentAccount = ({ accounts } = {}, accountId) => {
  return accounts.find(account => account.id === accountId);
};

export const getUserRole = ({ accounts } = {}, accountId) => {
  const currentAccount = getCurrentAccount({ accounts }, accountId) || {};
  return currentAccount.role || null;
};

export const routeIsAccessibleFor = (route, role, roleWiseRoutes) => {
  return roleWiseRoutes[role].includes(route);
};

const validateActiveAccountRoutes = (to, user, roleWiseRoutes) => {
  return null;
  // If the current account is active, then check for the route permissions
  const accountDashboardURL = `accounts/${to.params.accountId}/dashboard`;

  // If the user is trying to access suspended route, redirect them to dashboard
  if (to.name === 'account_suspended') {
    return accountDashboardURL;
  }

  const userRole = getUserRole(user, Number(to.params.accountId));
  const isAccessible = routeIsAccessibleFor(to.name, userRole, roleWiseRoutes);
  // If the route is not accessible for the user, return to dashboard screen
  return isAccessible ? null : accountDashboardURL;
};

export const validateLoggedInRoutes = (to, user, roleWiseRoutes) => {
  const currentAccount = getCurrentAccount(user, Number(to.params.accountId));

  // If current account is missing, either user does not have
  // access to the account or the account is deleted, return to login screen
  if (!currentAccount) {    
    return `app/login`;
  }

  const isCurrentAccountActive = currentAccount.status === 'active';

  if (isCurrentAccountActive) {
    return validateActiveAccountRoutes(to, user, roleWiseRoutes);
  }

  // If the current account is not active, then redirect the user to the suspended screen
  if (to.name !== 'account_suspended') {
    return `accounts/${to.params.accountId}/suspended`;
  }

  // Proceed to the route if none of the above conditions are met
  return null;
};

export const validateTypeAccountInRoutes = (to, accountType, typeAccountWiseRoutes) => {
  if(!accountType || !to.params?.accountId){
    return null;
  }  
  const accountDashboardURL = `accounts/${to.params.accountId}/${accountType === 'parent_account' ? 'subaccounts' : 'dashboard'}`;  
  return to.name != 'account_suspended' && typeAccountWiseRoutes[accountType].includes(to.name) ? null : accountDashboardURL;    
};

export const registerCookieLastBoardPage = (to, from, next) => {
  let path = "";
  let matched = null;
  if(to.name == "board_filter_status"){
    if(to.params.boardType != "teams" || to.params.status != "open"){
      next();
      return;
    }
    matched = to.matched.find(m => m?.name === to.name);
    if(matched){
      path = matched.path.replace(':boardType', 'teams').replace(':status', 'open');
    }
  }else{
    matched = to.matched.find(m => m?.name === to.name);
    path = (matched ? matched.path : '');
  }  
  setCookieWithDomain('cx_last_board_page', path, {
    expires: 30,
  });
  next();
};
